import cn from 'classnames'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import premiumtop from 'src/assets/premiumtop.png'
import { IconButton } from 'src/components/global/IconButton/IconButton'

import styles from '../../containers/Home/Home.module.scss'

interface UpgradeSectionProps {
  origin?: string
}

/**
 * Primary UI component for user interaction
 */
export const UpgradeSection: React.FC<UpgradeSectionProps> = ({ origin }) => {
  return (
    <div className="bg-clouds flex justify-center">
      <div className="!max-w-[1100px] w-full">
        <div className=" grid py-4 gap-[5rem] sm:grid-cols-2 justify-between">
          <div className="">
            <div className="md:float-left">
              <Image className="" src={premiumtop} alt="" />
            </div>
          </div>
          <div className="self-center float-right">
            <div className={cn(styles.homeBuyPremiumBadge)}></div>
            <div className="pt-[0.5rem] pb-[0.625rem] text-[1.5rem] font-bold font-secondary text-[#222222]">
              Upgrade to premium to gain access
              <br />
              to all articles and more
            </div>
            <div className="text-[1.125rem] font-primary font-regular text-darkgray">
              Get access to high-value expert-driven articles and
              <br />
              resources that improve transparency around
              <br />
              legaltech procurement, implementation and adoption.
            </div>
            <Link href={`/signup-premium/?origin=${origin}`}>
              <IconButton type="primary" label="Sign Up for Premium" className="w-[12.625rem] pt-5" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
